import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {
  RemindTypeOptions,
  URL,
  
} from "../../redux/actions/constants";

class RemindDetail extends Component {
  state = {
    pageTitle: "Hatırlatma Detay",
    pageTitleDetail: "Hatırlatma Detay",
    pageAddLink: "hatirlatma-ekle",
    pageListLink: "hatirlatma-listele",
    breadcrumb: [{ text: "Hatırlatma", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    remindDate: "",
    remindType: "",
    name: "",
    title: "",
    description: "",
    status: "",
    createdBy: "",
    createdAt: "",
    updatedAt: "",
    updatedBy: "",
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/reminds/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            remindDate: response.data.remindDate,
            remindType: response.data.remindType,
            name: response.data.name,
            title: response.data.title,
            description: response.data.description,
            status: response.data.status,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Card body className="table-responsive">
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}
              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>Tarih</th>
                    <td colSpan="4">
                      {this.state.remindDate ? this.state.remindDate : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Hatırlatma Tipi</th>
                    <td colSpan="4">
                      {this.state.remindType
                        ? RemindTypeOptions(this.state.remindType)
                        : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Ad Soyad</th>
                    <td colSpan="4">
                      {this.state.name === " " ? "-" : this.state.name}
                    </td>
                  </tr>

                  <tr>
                    <th>Başlık</th>
                    <td colSpan="4">
                      {this.state.title ? this.state.title : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Açıklama</th>
                    <td colSpan="4" dangerouslySetInnerHTML={{ __html: (this.state.description  ? this.state.description : "-") }}>
                    </td>
                  </tr>

                  <tr>
                    <th>Durum</th>
                    <td colSpan="4">{this.state.status ? "Aktif" : "Pasif"}</td>
                  </tr>

                  <tr>
                    <th>Kaydeden Kullanıcı</th>
                    <td>{this.state.createdBy ? this.state.createdBy : "-"}</td>
                    <th>Kaydedilme Tarihi</th>
                    <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                  </tr>
                  <tr>
                    <th>Son Güncelleyen Kullanıcı</th>
                    <td>{this.state.updatedBy ? this.state.updatedBy : "-"}</td>
                    <th>Son Güncellenme Tarihi</th>
                    <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                  </tr>
                </tbody>
              </Table>
            </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default RemindDetail;
